import React from "react";

const getInitials = (firstName, lastName) => {
  const firstInitial = firstName?.charAt(0).toUpperCase() || "";
  const lastInitial = lastName?.charAt(0).toUpperCase() || "";
  return `${firstInitial}${lastInitial}`;
};

const UserInitialsAvatar = ({ firstName, lastName, onClick }) => {
  const initials = getInitials(firstName, lastName);

  return (
    <button
      onClick={onClick}
      className="w-12 h-12 rounded-full flex items-center justify-center bg-[#009DE0] text-white font-bold text-sm hover:opacity-90 transition"
      aria-label="User menu"
      title={`${firstName} ${lastName}`}
    >
      {initials}
    </button>
  );
};

export default UserInitialsAvatar;
